<div style="display: block; height: 100%; width: 100%; position: relative">
  <google-map [height]="'100%'" [width]="'100%'"></google-map>
  <div
    class="direction-angle-container"
  >
  <span class="direction-angle-text">{{ (this.criticalPointController?.directionAngle.getValue() ?? 0).toFixed(2) }} °</span>

  </div>
</div>
